<template>
	<v-dialog scrollable persistent v-model="showDialog" max-width="820">
		<v-card>
			<v-card-title>Report Field</v-card-title>

			<v-card-text>
				<v-form ref="form">
					<v-row no-gutters>
						<v-text-field
							disabled
							v-if="hasCustomData"
							label="Schema"
							v-model="report.CustomData"
							:rules="[rules.required]"
						/>
						<v-select
							v-else
							label="Schema"
							v-model="schema"
							:items="schemas"
							item-value="Id"
							item-text="Name"
						/>
					</v-row>
					<v-row no-gutters>
						<v-text-field
							v-if="hasCustomData"
							label="Field"
							:rules="[rules.required]"
							v-model="source"
						/>
						<v-autocomplete
							v-else
							label="Field"
							:items="gridViewFields"
							item-value="Id"
							v-model="field"
							item-text="Label"
							:rules="[rules.required]"
						/>
					</v-row>
					<v-row no-gutters>
						<v-text-field
							label="Label"
							v-model="label"
							:rules="[rules.required]"
						/>
					</v-row>
				</v-form>
			</v-card-text>

			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn @click.stop="onClose">Close</v-btn>
				<v-btn color="primary" @click.stop="onSave">
					<v-icon class="mr-2">mdi-content-save</v-icon>Save
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import { ReportDetailsGetters } from '../../../../../store/getters';
import { ReportDetailsActions } from '../../../../../store/actions';
import { reportTypes } from '../../../../../enums/reportTypes';

export default {
	props: {
		showDialog: Boolean,
		reportField: Object,
		index: Number,
	},
	computed: {
		hasCustomData() {
			if (!this.report) return null;
			if (!this.report.Type) return false;
			return this.report.Type == reportTypes.CUSTOM_DATA;
		},
		...mapGetters({
			report: [ReportDetailsGetters.REPORT],
			reportGridViewFields: [ReportDetailsGetters.REPORT_GRIDVIEW_FIELDS],
			schemas: [ReportDetailsGetters.REPORT_FIELDS_SCHEMAS],
		}),

		gridViewFields() {
			if (!this.reportGridViewFields) return [];
			let usedFields = this.report.Fields.map((x) => x.GridViewFieldId);
			let availableFields = this.reportGridViewFields.filter(
				(f) => !usedFields.includes(f.Id)
			);
			if (this.selectedReportField)
				availableFields.push(
					this.reportGridViewFields.find(
						(x) => x.Id == this.selectedReportField
					)
				);
			if (!this.schema) return availableFields;
			let result = availableFields.filter(
				(x) => x.EntityId === this.schema
			);
			return result.sort((a, b) => (a.Label > b.Label ? 1 : -1));
			//test
		},
	},
	watch: {
		schema(newVal, oldVal) {
			if (oldVal && newVal) {
				this.field = null;
				this.source = null;
			}
		},
	},
	data() {
		return {
			rules: {
				required: (value) => !!value || 'Field is required',
			},

			schema: null,
			field: null,
			selectedReportField: null,
			label: null,
			source: null,
		};
	},
	mounted() {
		if (this.reportField) {
			if (!this.hasCustomData) this.setSchema();
			this.label = this.reportField.Label;
			this.field = this.reportField.GridViewFieldId;
			this.selectedReportField = this.reportField.GridViewFieldId;
			this.source = this.reportField.Source;
		}
	},

	methods: {
		setSchema() {
			if (this.schemas && this.reportGridViewFields) {
				let gvf = this.reportGridViewFields.find(
					(x) => x.Id == this.reportField.GridViewFieldId
				);
				if (gvf) {
					let schema = this.schemas.find((x) => x.Id == gvf.EntityId);
					this.schema = schema.Id;
				}
			}
		},
		onClose() {
			this.$emit('close');
		},
		onSave() {
			if (!this.$refs.form.validate()) return;
			if (!this.reportField) {
				this.addReportField();
			} else {
				this.updateReportField();
			}
		},
		addReportField() {
			let reportField = {
				ReportId: this.report.Id,
				Label: this.label,
				GridViewFieldId: this.field,
				Source: this.source,
				Order: this.index + 1,
			};

			this.$store
				.dispatch(ReportDetailsActions.ADD_REPORT_FIELD, reportField)
				.then((success) => {
					if (!success) return;
					this.$emit('close');
				});
		},

		updateReportField() {
			this.reportField.Label = this.label;
			this.reportField.GridViewFieldId = this.field;
			this.reportField.Source = this.source;
			this.$store
				.dispatch(
					ReportDetailsActions.UPDATE_REPORT_FIELD,
					this.reportField
				)
				.then((success) => {
					if (!success) return;
					this.$emit('close');
				});
		},
	},
};
</script>
